export const BotTrainingStatusName = {
  Completed: 'Completed',
  InProgress: 'InProgress',
  NeedsTraining:'NeedsTraining'
}
